import { isNumber, isString } from './is';
export var ConvertTypeEnum;
(function (ConvertTypeEnum) {
    ConvertTypeEnum[ConvertTypeEnum["Object"] = 1] = "Object";
    ConvertTypeEnum[ConvertTypeEnum["Array"] = 2] = "Array";
    ConvertTypeEnum[ConvertTypeEnum["String"] = 3] = "String";
    ConvertTypeEnum[ConvertTypeEnum["Number"] = 4] = "Number";
})(ConvertTypeEnum || (ConvertTypeEnum = {}));
/**
 * 将其它类型转换为`string`
 */
export function convertString(value) {
    if (isString(value))
        return value;
    // 支持将number转换为字符串
    if (isNumber(value))
        return value === Infinity || isNaN(value) ? '' : String(value);
    // if (isEmptyArray(value)) return '';
    // if (!value) return '';
    // return value;
    // 非字符串类型，都转为空字符串
    return '';
}
/**
 * 将其它类型转换为`number`
 */
export function convertNumber(value) {
    if (isNumber(value)) {
        if (value === Infinity)
            return 0;
        if (isNaN(value))
            return 0;
        return value;
    }
    if (isString(value)) {
        var v = Number(value);
        return isNaN(v) ? 0 : v;
    }
    return 0;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29udmVydC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb3JlL2NvbnZlcnQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFFLFFBQVEsRUFBRSxRQUFRLEVBQUUsTUFBTSxNQUFNLENBQUM7QUFFMUMsTUFBTSxDQUFOLElBQVksZUFLWDtBQUxELFdBQVksZUFBZTtJQUN6Qix5REFBVSxDQUFBO0lBQ1YsdURBQUssQ0FBQTtJQUNMLHlEQUFNLENBQUE7SUFDTix5REFBTSxDQUFBO0FBQ1IsQ0FBQyxFQUxXLGVBQWUsS0FBZixlQUFlLFFBSzFCO0FBc0JEOztHQUVHO0FBQ0gsTUFBTSxVQUFVLGFBQWEsQ0FBSSxLQUFRO0lBQ3ZDLElBQUksUUFBUSxDQUFDLEtBQUssQ0FBQztRQUFFLE9BQU8sS0FBSyxDQUFDO0lBQ2xDLGtCQUFrQjtJQUNsQixJQUFJLFFBQVEsQ0FBQyxLQUFLLENBQUM7UUFDakIsT0FBTyxLQUFLLEtBQUssUUFBUSxJQUFJLEtBQUssQ0FBQyxLQUFLLENBQUMsQ0FBQyxDQUFDLENBQUMsRUFBRSxDQUFDLENBQUMsQ0FBQyxNQUFNLENBQUMsS0FBSyxDQUFDLENBQUM7SUFDakUsc0NBQXNDO0lBQ3RDLHlCQUF5QjtJQUN6QixnQkFBZ0I7SUFFaEIsaUJBQWlCO0lBQ2pCLE9BQU8sRUFBRSxDQUFDO0FBQ1osQ0FBQztBQUVEOztHQUVHO0FBQ0gsTUFBTSxVQUFVLGFBQWEsQ0FBSSxLQUFRO0lBQ3ZDLElBQUksUUFBUSxDQUFDLEtBQUssQ0FBQyxFQUFFO1FBQ25CLElBQUksS0FBSyxLQUFLLFFBQVE7WUFBRSxPQUFPLENBQUMsQ0FBQztRQUNqQyxJQUFJLEtBQUssQ0FBQyxLQUFLLENBQUM7WUFBRSxPQUFPLENBQUMsQ0FBQztRQUMzQixPQUFPLEtBQUssQ0FBQztLQUNkO0lBQ0QsSUFBSSxRQUFRLENBQUMsS0FBSyxDQUFDLEVBQUU7UUFDbkIsSUFBTSxDQUFDLEdBQUcsTUFBTSxDQUFDLEtBQUssQ0FBQyxDQUFDO1FBQ3hCLE9BQU8sS0FBSyxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQztLQUN6QjtJQUNELE9BQU8sQ0FBQyxDQUFDO0FBQ1gsQ0FBQyJ9